function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".voice_apps_svg__cls-1{fill:#f5f8fc}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "voice_apps_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "voice_apps_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "voice_apps_svg__cls-1",
  d: "M9.17 0a4.06 4.06 0 00-4.06 4.05v7.08a4.06 4.06 0 008.13 0V4.05A4.07 4.07 0 009.17 0zM11 11.13a1.87 1.87 0 01-2.21 1.82A1.93 1.93 0 017.31 11V4a1.87 1.87 0 013.73 0z"
}), React.createElement("path", {
  className: "voice_apps_svg__cls-1",
  d: "M18.39 11.17a9.17 9.17 0 01-8 9.06h-.14v3.67A1.1 1.1 0 019.17 25a1.1 1.1 0 01-1.1-1.1v-3.66h-.14A9.19 9.19 0 010 11.17a1.1 1.1 0 012.2 0 7 7 0 0014 0 1.1 1.1 0 012.2 0z"
})));

var SvgVoiceApps = function SvgVoiceApps(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18.39 25"
  }, props), _ref, _ref2);
};

export default SvgVoiceApps;